import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //会议报名active
    active:1,
    //注册active
    active1:1,
    //报名填写人员信息
    changePersonFormIndex:'',

    confId:"",

    //保存路由
    router:'',
  },
  mutations: {
    changeConfId:(state,id)=>{
      state.confId = id
    },
    addActive: (state) => {
      state.active += 1
    },
    subActive: (state) => {
      state.active -= 1
    },
    addActive1: (state) => {
      state.active1 += 1
    },
    subActive1: (state) => {
      state.active1 -= 1
    },


    saveChangePersonFormIndex: (state, avatar) => {
      state.changePersonFormIndex = avatar
    },
    saveRouter: (state, avatar) => {
      state.router = avatar
    },
  },
  actions: {
    addActive ({commit}) {
      commit('addActive')
    },
    subActive ({commit}) {
      commit('subActive')
    },
    addActive1 ({commit}) {
      commit('addActive1')
    },
    subActive1 ({commit}) {
      commit('subActive1')
    },
    saveChangePersonFormIndex ({commit},payload) {
      commit('saveChangePersonFormIndex',payload)
    },
    saveRouter ({commit},payload) {
      commit('saveRouter',payload)
    },
  },
  modules: {
  }
})
